import { isSameId } from "../../helpers";
export default function (store, { id, before }) {
    const { columns } = store.getState();
    const columnIndex = columns.findIndex(col => isSameId(col.id, id));
    const afterColumn = columns[columnIndex + 1]?.id;
    const col = columns.splice(columnIndex, 1)[0];
    if (before) {
        const beforeColumnIndex = columns.findIndex(col => isSameId(col.id, before));
        columns.splice(beforeColumnIndex, 0, col);
    }
    else {
        columns.push(col);
    }
    store.setState({ columns });
    return () => {
        store.in.exec("move-column", {
            id,
            before: afterColumn,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=move.js.map